export type ClientSearchValue = string | number | boolean | null | undefined;

export function matchesClientSearch(query: string, values: ClientSearchValue[]): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return values.some((value) =>
    String(value ?? "")
      .toLowerCase()
      .includes(needle)
  );
}

export function filterByClientSearch<T>(rows: T[], query: string, getValues: (row: T) => ClientSearchValue[]): T[] {
  if (!query.trim()) return rows;
  return rows.filter((row) => matchesClientSearch(query, getValues(row)));
}
